export const inlineImageDataIdAttribute = 'data-inline-src-id';
